var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',_vm._g({style:({
   minWidth: '35px',
   maxWidth: '35px',
   minHeight: '35px',
   maxHeight: '35px'
 }),attrs:{"disabled":_vm.disabled,"loading":_vm.loading,"icon":""}},_vm.$listeners),[_c('v-icon',[_vm._v(_vm._s(_vm.icons))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }